export default __webpack_public_path__ + "static/media/rit.90966992.png";